/* globals YT */

import React from 'react';
import ReactDOM from 'react-dom';
import ImageWithTransition from '../components/map-preview-ui/ImageWithTransition';
import MapsByStateGallery from '../components/map-preview-ui/MapsByStateGallery';
import MapWithLinks from '../components/map-preview-ui/MapWithLinks';
import HuntingMapPreview from '../components/map-preview-ui/HuntingMapPreview';
import MapGalleryPreview from '../components/map-preview-ui/MapGalleryPreview';
import getQueryParams from '../utils/getQueryParams';
import trackAnalytics from '../utils/gaia/trackAnalytics';

window.MapPreviewUI = {};

window.MapPreviewUI.showBigMapPreview = ({props, selector}) => {
    ReactDOM.render(
        <HuntingMapPreview {...props}  />,
        window.document.querySelector(selector)
    );
};

window.MapPreviewUI.showMapGalleryPreview = ({props, selector}) => {
    ReactDOM.render(
        <MapGalleryPreview {...props}  />,
        window.document.querySelector(selector)
    );
};


window.MapPreviewUI.showMapWithLinks = ({props, selector}) => {
    ReactDOM.render(
        <MapWithLinks {...props}  />,
        window.document.querySelector(selector)
    );
};


const showMapsByState = ({props, selector}) => {
    ReactDOM.render(
        <MapsByStateGallery {...props}  />,
        window.document.querySelector(selector)
    );
};


window.MapPreviewUI.showImageWithTransition = ({props, selector}) => {
    ReactDOM.render(
        <ImageWithTransition {...props}  />,
        window.document.querySelector(selector)
    );
};


const track = (event, selector, info) => {
    const elem = document.getElementById(selector);
    // check if it exists because buttons get hidden in some states
    if (elem) {
        elem.addEventListener('click', () => {
            trackAnalytics(event, {...info, ...window.huntAppEventInfo});
        });
    }
};


window.MapPreviewUI.setupScrollAnchors = anchors => {
    for (const anchor of anchors) {
        const elem = document.getElementById(anchor['buttonAnchor']);
        // check if it exists because buttons get hidden in some states
        if (elem) {
            elem.addEventListener('click', () => {
                scrollToElement(
                    document.getElementById(anchor['scrollAnchor']),
                    {offset: anchor['offset']}
                );
                track('View Maps', anchor['buttonAnchor']);
            });
        }
    }
};


// even though he says he'd use a polyfill:
// https://pawelgrzybek.com/page-scroll-in-vanilla-javascript/
function scrollToElement(destination, {duration = 300, easing = 'linear', offset = 0, callback}) {
    const easings = {
        linear(t) {
            return t;
        },
        easeInQuad(t) {
            return t * t;
        },
        easeOutQuad(t) {
            return t * (2 - t);
        },
        easeInOutQuad(t) {
            return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic(t) {
            return t * t * t;
        },
        easeOutCubic(t) {
            return (--t) * t * t + 1;
        },
        easeInOutCubic(t) {
            return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart(t) {
            return t * t * t * t;
        },
        easeOutQuart(t) {
            return 1 - (--t) * t * t * t;
        },
        easeInOutQuart(t) {
            return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
        },
        easeInQuint(t) {
            return t * t * t * t * t;
        },
        easeOutQuint(t) {
            return 1 + (--t) * t * t * t * t;
        },
        easeInOutQuint(t) {
            return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t;
        }
    };

    const start = window.pageYOffset;
    const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

    const documentHeight = Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.clientHeight,
        document.documentElement.scrollHeight,
        document.documentElement.offsetHeight
    );

    const windowHeight = (
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.getElementsByTagName('body')[0].clientHeight
    );

    const destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
    let destinationOffsetToScroll = Math.round(
        documentHeight - destinationOffset < windowHeight ?
            documentHeight - windowHeight :
            destinationOffset
    );
    destinationOffsetToScroll -= offset;

    if ('requestAnimationFrame' in window === false) {
        window.scroll(0, destinationOffsetToScroll);
        if (callback) {
            callback();
        }
        return;
    }

    function scroll() {
        const now = 'now' in window.performance ? performance.now() : new Date().getTime();
        const time = Math.min(1, ((now - startTime) / duration));
        const timeFunction = easings[easing](time);
        window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start));

        if (window.pageYOffset === destinationOffsetToScroll) {
            if (callback) {
                callback();
            }
            return;
        }

        requestAnimationFrame(scroll);
    }

    scroll();
}

window.MapPreviewUI.setupHuntForStateUI = info => {
    showMapsByState({
        props: {
            baseSource: info.baseSource,
            initialState: info.state,
            sources: info.huntSourcesByState,
            stateIDs: info.stateIDs,
            stateNames: info.stateNames,
        },
        selector: info.selectors.mapsByState
    });
    window.MapPreviewUI.setupScrollAnchors(info.scrollAnchors);
    // analytics
    window.huntAppEventInfo = {category: 'Commerce', page: info.analyticsPage};
    track('Sign Up', info.selectors.signupButton);
    track('Blog Hunt Category', info.selectors.blogHuntCategory);
    track('Blog Howto Hunt', info.selectors.howToBlog);
    for (const state of info.states) {
        track('Click State Link', state.slug, {state: state.name});
    }
    // https://megalytic.com/blog/tracking-youtube-videos-using-google-analytics
    // This code loads the IFrame Player API code asynchronously
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
};


window.MapPreviewUI.setupHuntUI = info => {
    showMapsByState({
        props: {
            baseSource: info.baseSource,
            initialState: info.state,
            isAndroid: info.isAndroid,
            isIOS: info.isIOS,
            sources: info.huntSourcesByState,
            stateIDs: info.stateIDs,
            stateNames: info.stateNames,
        },
        selector: info.selectors.mapsByState
    });
    window.MapPreviewUI.showImageWithTransition({
        props: {
            images: info.images,
        },
        selector: info.selectors.featureImage
    });
    window.MapPreviewUI.setupScrollAnchors(info.scrollAnchors);

    // analytics
    window.huntAppEventInfo = {category: 'Commerce', page: info.analyticsPage};
    track('Sign Up', info.selectors.signupButton);
    track('Blog Hunt Category', info.selectors.blogHuntCategory);
    track('Blog Howto Hunt', info.selectors.howToBlog);
    for (const state of info.states) {
        track('Click State Link', state.slug, {state: state.name});
    }
    // https://megalytic.com/blog/tracking-youtube-videos-using-google-analytics
    // This code loads the IFrame Player API code asynchronously
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

};

let pauseFlag = false;

function onPlayerStateChange(event) {
    // track when user clicks to Play
    if (event.data === YT.PlayerState.PLAYING) {
        trackAnalytics('Video Play', {category: 'Commerce',  page: '{{analytics_page}}'});
        pauseFlag = true;
    }
    // track when user clicks to Pause
    if (event.data === YT.PlayerState.PAUSED && pauseFlag) {
        trackAnalytics('Video Pause', {category: 'Commerce',  page: '{{analytics_page}}'});
        pauseFlag = false;
    }
    // track when video ends
    if (event.data === YT.PlayerState.ENDED) {
        trackAnalytics('Video Finish', {category: 'Commerce',  page: '{{analytics_page}}'});
    }
}

// This code is called by the YouTube API to create the player object
export function onYouTubeIframeAPIReady() {
    return new YT.Player('youTubePlayer', {
        events: {
            onStateChange: onPlayerStateChange
        }
    });
}


window.MapPreviewUI.getQueryParams = queryString => {
    return getQueryParams(queryString);
};
